import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum AGENT_FORM_FIELDS {
	FIRST_NAME = 'FirstName',
	LAST_NAME = 'LastName',
	EMAIL = 'Email',
	PHONE = 'Phone',
}

export enum AGENT_FORM_FIELDS_NAMES {
	FIRST_NAME = 'NEW_APPLICATION.LABEL.FIRST_NAME',
	LAST_NAME = 'NEW_APPLICATION.LABEL.LAST_NAME',
	EMAIL = 'NEW_APPLICATION.LABEL.EMAIL',
	PHONE = 'NEW_APPLICATION.LABEL.PHONE',
}

export type AgentTypes = {
	[AGENT_FORM_FIELDS.FIRST_NAME]: string,
	[AGENT_FORM_FIELDS.LAST_NAME]: string,
	[AGENT_FORM_FIELDS.EMAIL]: string,
	[AGENT_FORM_FIELDS.PHONE]: string | number,
}

export type AgentReturnTypes = {
	name?: string,
	firstName: string,
	lastName: string,
	email: string,
	phone: string,
	id?: string,
	role?: string,
}

export const getAdminDetailsSchema = (t: TFunction): Yup.SchemaOf<AgentTypes> => Yup.object<Shape<AgentTypes>>().shape({
	[AGENT_FORM_FIELDS.FIRST_NAME]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.FIRST_NAME_REQUIRED')),
	[AGENT_FORM_FIELDS.LAST_NAME]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.LAST_NAME_REQUIRED')),
	[AGENT_FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
	[AGENT_FORM_FIELDS.PHONE]: Yup.number()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),
});

export const initialAgentValues: AgentTypes = {
	[AGENT_FORM_FIELDS.FIRST_NAME]: '',
	[AGENT_FORM_FIELDS.LAST_NAME]: '',
	[AGENT_FORM_FIELDS.EMAIL]: '',
	[AGENT_FORM_FIELDS.PHONE]: '',
};

export const getFormattedAdminFormFields = (formikValues): AgentReturnTypes => ({
	name: formikValues?.[AGENT_FORM_FIELDS.FIRST_NAME],
	firstName: formikValues?.[AGENT_FORM_FIELDS.FIRST_NAME],
	lastName: formikValues?.[AGENT_FORM_FIELDS.LAST_NAME],
	email: formikValues?.[AGENT_FORM_FIELDS.EMAIL],
	phone: formikValues?.[AGENT_FORM_FIELDS.PHONE],
});

export const convertToAdminInitial = (data): AgentTypes => ({
	[AGENT_FORM_FIELDS.FIRST_NAME]: data?.contact?.firstName ? data?.contact?.firstName : '',
	[AGENT_FORM_FIELDS.LAST_NAME]: data?.contact?.lastName ? data?.contact?.lastName : '',
	[AGENT_FORM_FIELDS.EMAIL]: data?.contact?.email ? data?.contact?.email : '',
	[AGENT_FORM_FIELDS.PHONE]: data?.contact?.phone ? data?.contact?.phone : '',
});

export interface IAgent {
	id?: string,
	contact: {
		firstName: string,
		lastName: string,
		email: string,
		phone: string,
		userActive: boolean,
		role: string
	},
}

export enum SALES_ROLES {
	SALES_AGENCY_ADMIN = 'SALESAGENCY_ADMIN',
	SALES_AGENCY_AGENT = 'SALESAGENCY_AGENT'
}

export const AGENT_ROLES = [
	{
		value: SALES_ROLES.SALES_AGENCY_ADMIN,
		label: 'Administrator',
	},
	{
		value: SALES_ROLES.SALES_AGENCY_AGENT,
		label: 'Agent',
	},
];
